<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Rota das Emoções</v-card-title>
            <v-card-text class="app-card-content">
              <v-form
                ref="form"
                v-model="form.valid"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      type="text"
                      label="Placa *"
                      placeholder="Ex.: GDX-1B34"
                      v-mask="'AAA-#X##'"
                      v-model="form.placa"
                      :rules="[rules.required]"
                      class="placa"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12" class="pt-0">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12" class="pt-0">
                    <v-btn depressed block large color="primary" type="submit"
                      >Continuar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
          <br />
          <div id="resultadoRotaEmocoes"></div>
          <ResultadoRotaEmocoes :veiculo="veiculo" v-if="veiculo" />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import GlobalStore from "@/store/modules/global";
import SebraeCarroService from "@/services/sebraeCarro.service";
import { SebraeCarro } from "@/models/sebraeCarro";
import { delay } from "rxjs/operators";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";
import ResultadoRotaEmocoes from "@/views/transportes/rota-emocoes/Resultado";

export default Vue.extend({
  components: {
    VueRecaptcha,
    ResultadoRotaEmocoes
  },
  directives: {
    mask
  },
  metaInfo: {
    title: "Rota das Emoções - Central de Serviços"
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      form: {
        valid: false,
        recaptcha: null,
        placa: ""
      },
      veiculo: null,
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        pattern: value =>
          !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
          "Esse campo está fora do padrão"
      }
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.carregaVeiculo();
      }
    },
    carregaVeiculo() {
      this.isLoading = true;
      const { placa, recaptcha } = this.form;
      SebraeCarroService.findBy(placa, recaptcha).subscribe(
        response => {
          this.veiculo = response;
          this.isLoading = false;
          //this.$refs.form.reset();
          this.$vuetify.goTo("#resultadoRotaEmocoes");
          this.expiredRecaptcha();
        },
        error => {
          this.isLoading = false;
          this.veiculo = null;
          //this.$refs.form.reset();
          this.expiredRecaptcha();
        }
      );
    }
  }
});
</script>
